import {useState, useEffect} from 'react'
import { Box, Typography, TextField, MenuItem, InputAdornment} from '@mui/material'
import QuestionsTable from './QuestionsTable'
import { getAllQuestions, getUserSubmissions } from '../api/axios';
import SearchIcon from '@mui/icons-material/Search';


export default function Playground({topicData}) {
    const [userSubmissions, setUserSubmissions] = useState([])
    const [questionData, setQuestionData] = useState([])
    const [topicName, setTopicName] = useState("all")
    const [allQuestions, setAllQuestions] = useState([])
    const [search, setSearch] = useState("")

    const slugify = (str) => {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    }

    useEffect(() => {
        const fetchAllQuestions = async () => {
            try {
                const response = await getAllQuestions()
                setAllQuestions(response.data)
                setQuestionData(response.data)
            } catch (error) {
                console.error(`Error getting topics: ${error}`)
            }
        }
        fetchAllQuestions()
    }, [])

    useEffect(() => {
        const fetchUserSubmissions = async () => {
            try {
                const response = await getUserSubmissions()
                setUserSubmissions(response.data)
            } catch (error) {
                console.error(`Error getting submissions: ${error}`)
            }
        }
        fetchUserSubmissions()
    }, [])

    const handleTopicChange = (topicData) => {
        setTopicName(topicData)
        setSearch("")
        if (topicData === "all") {
            setQuestionData(allQuestions)
        }
        else{
            setQuestionData(allQuestions.filter(question => question.tags.includes(topicData)))
        }
    }

    const handleSearchChange = (searchData) => {
        setSearch(searchData)
        setTopicName("all")
        setQuestionData(allQuestions.filter((question) => question.title.toLowerCase().includes(searchData.toLowerCase())))
    }

    return (
        <Box sx={{
            width: '100%',
            height: '100%',
            marginTop: '3%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        }}>

            <Typography sx={{color: '#E1E1E6'}}>
                Search for any problems here - 
                <span style={{
                    background: 'linear-gradient(316.91deg, #A29EDA -26.21%, #B292D1 -10.9%, #B557AF 64.77%, #6B3A8F 94.98%, #5D2A79 115.46%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}>
                    {" "}happy solving!
                </span>
            </Typography>

            <Box sx={{
                width:'100%',
                height: '6%',
                marginTop: '3%',
                display: 'flex',
            }}>
                <TextField 
                    data-cy='pg-searchbar'
                    variant='outlined'
                    type="search" 
                    value={search}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment>
                                <SearchIcon sx={{color: '#E1E1E6'}} />
                            </InputAdornment>
                        ),
                        sx: {
                            background: '#211F22',
                            height: "100%", // Adjust input height
                            color: '#E1E1E6'
                        },
                    }}
                    sx={{
                        width: '60%',
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "24px",
                            "& fieldset": {
                            borderColor: "gray",
                            },
                            "&:hover fieldset": {
                            borderColor: "#B292D1",
                            },
                            "&.Mui-focused fieldset": {
                            borderColor: "#B292D1", 
                            borderWidth: "2px", 
                            },
                        }

                }}/>

                <TextField
                    select
                    value={topicName}
                    onChange={(e) => handleTopicChange(e.target.value)}
                    InputProps={{
                        sx: {
                            background: '#211F22',
                            height: "100%", // Adjust input height
                            color: '#E1E1E6',
                        },
                    }}
                    sx={{
                        width: '35%',
                        marginLeft: '2%',
                        "& .MuiOutlinedInput-root": {
                            borderRadius: "24px",
                            "& fieldset": {
                            borderColor: "gray",
                            },
                            "&:hover fieldset": {
                            borderColor: "#B292D1",
                            },
                            "&.Mui-focused fieldset": {
                            borderColor: "#B292D1", 
                            borderWidth: "2px", 
                            },
                        }
                    }}
                >
                    <MenuItem value={"all"}>
                        All Questions
                    </MenuItem>
                    {topicData.map((option, index) => (
                        <MenuItem key={index} value={option.name} data-cy={`topic-menuitem-${option.name}`}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>

            <Box sx={{
                width:'100%',
                height: '10%',
                display: 'grid',
                paddingTop: '3%',
                gridTemplateColumns:'2fr 1fr', 
                textAlign: 'center',
                gap: 2
            }}>
                    <Typography sx={{color: 'E1E1E6'}}>Problem</Typography>
                    <Typography sx={{color: 'E1E1E6'}}>Status</Typography> {/* TODO: Change to RUNTIME */}
            </Box>

            <Box sx={{
                width: '100%',
                minHeight: '70%',
                maxHeight: '70%',
                overflow: 'auto',
                textAlign: 'center',
                marginTop:'2%'
            }}> 
            {console.log(userSubmissions)}
                {questionData.map((question, index) => {
                    const completedQuestions = userSubmissions.map(submissions => submissions.idQuestion)
                    if (completedQuestions.includes(question._id)) {
                        const questionSubmitted = userSubmissions.find(submission => submission.idQuestion.toString() === question._id.toString())
                        return (
                            <QuestionsTable key={index} question={question} status={questionSubmitted.results}/>
                        )
                    }
                    else {
                        return (
                            <QuestionsTable key={index} question={question} status={"Not Completed"}/>
                        )
                    }
                })}
            </Box>

        </Box>
    )
}